import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useMe } from "@/modules/auth/hooks/useAuth";
import { PageHeader } from "@/shared/components/PageHeader";
import { useUrlTableState } from "@/shared/hooks/useUrlState";
import { DeviceFormModal } from "../components/DeviceFormModal";
import { DeviceTable } from "../components/DeviceTable";
import { useDevicesStore } from "../store/devices.store";

export function DevicesPage() {
	const { page, limit, setPage } = useUrlTableState();

	const { data: meUser } = useMe();
	const openCreateModal = useDevicesStore((s) => s.openCreateModal);

	const organizations = meUser?.organizations ?? [];

	return (
		<div>
			<PageHeader
				title="FaceID qurilmalari"
				action={
					<Button
						type="primary"
						icon={<PlusOutlined />}
						onClick={openCreateModal}
						id="devices-create-btn"
					>
						Qo'shish
					</Button>
				}
			/>

			<DeviceTable page={page} limit={limit} onPageChange={setPage} />
			<DeviceFormModal organizations={organizations} />
		</div>
	);
}
